import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarEvent } from 'angular-calendar';
import { EventViewDetails } from 'src/app/models/dialogs-models/event-view-details';

@Component({
  selector: 'app-event-details-modal',
  templateUrl: './event-details-modal.component.html',
  styleUrls: ['./event-details-modal.component.scss']
})
export class EventDetailsModalComponent implements OnInit {

  eventDetails: EventViewDetails;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CalendarEvent<{ description: string }>
  ) { }

  ngOnInit(): void {
    this.data.start = new Date(this.data.start);
    this.data.end = new Date(this.data.end);
    this.eventDetails = this.convertToEventDetails(this.data);
    
  }

  convertToEventDetails(calendarEvent: CalendarEvent<{ description: string }>): EventViewDetails {
    //console.log('Evento arrivato alla modale:');
    //console.log(calendarEvent);
    
    let eventPeriod: string;

    if (this.datesAreEquals(calendarEvent.start, calendarEvent.end)) {
      eventPeriod = `In data: ${this.formattedDate(calendarEvent.start)}`;
    } else {
      eventPeriod = `Dal ${this.formattedDate(calendarEvent.start)} al ${this.formattedDate(calendarEvent.end)} ogni ---`;
    }

    const startingTime: string = [
      calendarEvent.start.getHours(),
      calendarEvent.start.getMinutes()
    ].map(this.formatDateData)
    .join(':');

    const endTime: string = [
      calendarEvent.end.getHours(),
      calendarEvent.end.getMinutes()
    ].map(this.formatDateData)
    .join(':');

    //console.log(startingTime);
    //console.log(endTime);
    
    return {
      title: calendarEvent.title,
      period: eventPeriod,
      startingTime: `Ora inizio: ${startingTime}`,
      endTime: `Ora fine: ${endTime}`,
      description: calendarEvent.meta.description
    };
  }

  formattedDate = (dateObject: Date): string => {
    const day = dateObject.getDate();
    const month = dateObject.getMonth() + 1;
    const year = dateObject.getFullYear();

    return [this.formatDateData(day), this.formatDateData(month), year].join('/');
  }

  datesAreEquals = (date1: Date, date2: Date): boolean => {
    return date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate();
  }

  formatDateData = (data: number): string =>
    data.toString().length === 1
      ? `0${data}`
      : data.toString()

}
